import { render, staticRenderFns } from "./RegistrationConfirmData.vue?vue&type=template&id=bb965236&scoped=true&"
import script from "./RegistrationConfirmData.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirmData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb965236",
  null
  
)

export default component.exports